import React, { useEffect, useMemo, isValidElement } from 'react';
import { ChatRoomLink } from './help-links';
import { ReportError } from './error-reporting';
import { PanelTypeEnum } from './constants';
import './error-message-on-info-panel.scss';

interface Props {
  title?: string;
  message: React.ReactNode | string;
  helpContent?: React.ReactElement;
  enableReporting?: boolean;
  requestTraceId?: string;
  serviceName?: string;
  enableTicketCreationOption?: boolean;
}

//Title is now same across the application, so removed it from props
export const ErrorMessageOnInfoPanel = ({
  message,
  helpContent,
  enableReporting = false,
  enableTicketCreationOption,
  requestTraceId,
  serviceName,
}: Props) => {
  const errorMessageRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (errorMessageRef.current) {
      scrollToMessage();
    }
  }, [errorMessageRef.current]);

  const messageContent = useMemo(() => {
    if (typeof message === 'string') {
      return <div dangerouslySetInnerHTML={{ __html: message }} />;
    }
    return message;
  }, [message]);

  const scrollToMessage = () => {
    if (errorMessageRef && errorMessageRef.current) {
      // if this method is giving you an error in your unit test. Heres your fix
      //https://github.com/jsdom/jsdom/issues/1695
      errorMessageRef.current.scrollIntoView(false);
    }
  };

  return (
    <div tabIndex={0} ref={errorMessageRef} className="error-message-info-panel">
      <div id="error-message-test" data-testid="error-message-test">
        We’re unable to make the change because:
      </div>
      <div style={{ margin: '8px' }}>
        <ul>
          <li>
            <strong>{messageContent}</strong>
          </li>
        </ul>
      </div>
      {isValidElement(helpContent) ? (
        <div>{helpContent}</div>
      ) : (
        <div className="contact-message-container">
          {enableReporting ? (
            <>
              <span>Still having trouble? </span>
              <ReportError
                errorMessage={typeof message === 'string' ? message : 'Error'}
                type={PanelTypeEnum.INFO_PANEL}
                requestTraceId={requestTraceId}
                serviceName={serviceName}
                enableTicketCreationOption={enableTicketCreationOption}
              />
            </>
          ) : (
            <div>
              Still having trouble? Contact the <ChatRoomLink />.
            </div>
          )}
        </div>
      )}
    </div>
  );
};
